import * as BX from 'main.core';
const $ = window.jQuery;

const $window = $(window);
let $heighText, $showLink;

function showFullDescription() {

    if ($window.width() <= '559' && $heighText.height() >= 161) {
        $showLink.addClass('b-sectionInfo__show_visible');
    }

    if ($window.width() >= '560' && $window.width() <= '767' && $heighText.height() >= 175) {
        $showLink.addClass('b-sectionInfo__show_visible');
    }

    $showLink.text(BX.message('CITRUS_APRODUCTION3_COLLAPSED_TEXT_SHOW'));
}

function onReady() {
    $heighText = $('.b-sectionInfo__text');
    $showLink = $('.b-sectionInfo__show');

    $showLink.on('click', event => {
        event.preventDefault();
        if ($heighText.hasClass('b-sectionInfo__text_full')) {
            $showLink.text(BX.message('CITRUS_APRODUCTION3_COLLAPSED_TEXT_SHOW'));
            $heighText.removeClass('b-sectionInfo__text_full');
        } else {
            $showLink.text(BX.message('CITRUS_APRODUCTION3_COLLAPSED_TEXT_HIDE'));
            $heighText.addClass('b-sectionInfo__text_full');
        }
    });
    showFullDescription();

    // скрыть описание в блоке о компании для мобильных разрешений
    $(window).on('resize', showFullDescription);
}

$(onReady);

